import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import './CraneInspectionFormFailOptions.css';
import * as constants from 'constants/App';
import Spinner from 'components/Spinner';

class CraneInspectionFormFailOptions extends React.Component {	
	handleYesClick = () => {
		this.props.onYesClick();
	}

	handleNoClick = () => {
		this.props.onNoClick();
	}


	render() {
		const messages = defineMessages({			
			crane_inspection_form__fail_confirm_title: {
                id: 'crane_inspection_form__fail_confirm_title',
                description: 'Crane Inspection - fail confirmation title',
                defaultMessage: 'Crane inspection'
            }, 
			crane_inspection_form__fail_confirm_question: {
                id: 'crane_inspection_form__fail_confirm_question',
                description: 'Crane Inspection - fail confirmation question',
                defaultMessage: 'Are you going to repair the failed vehicle components on this repair invoice?'
			},
			crane_inspection_form__fail_confirm_yes: {
                id: 'crane_inspection_form__fail_confirm_yes',
                description: 'Crane Inspection form - fail yes button text',
                defaultMessage: 'Yes and edit PO'
            },
            crane_inspection_form__fail_confirm_no: {
                id: 'crane_inspection_form__fail_confirm_no',
                description: 'Crane Inspection form - fail No button text',
                defaultMessage: 'No and continue'
			},						
		});

		return (
			<div className='crane_inspection_form_fail_options'>
				
				<div className='crane_inspection_form_fail_options__title'>
					<FormattedMessage {...messages.crane_inspection_form__fail_confirm_title} />
				</div>

				<div className='crane_inspection_form_fail_options__question'>
					<FormattedMessage {...messages.crane_inspection_form__fail_confirm_question} />
				</div>

				<div className='row'>
					<div 
						className='col-sm-6 crane_inspection_form_fail_options__answer' 
						onClick={this.handleYesClick}
					>
						<img src="/assets/VMS_28button_kill_clear.png" />{' '}
						<FormattedMessage {...messages.crane_inspection_form__fail_confirm_yes} />
					</div>
					<div 
						className='col-sm-6 crane_inspection_form_fail_options__answer text-right' 
						onClick={this.handleNoClick}
					>
						<FormattedMessage {...messages.crane_inspection_form__fail_confirm_no} />
						{' '}<img src="/assets/VMS_33button_go_bblue.png" />
						<div className='crane_inspection_form__spinner'>
							{this.props.isSaving &&
								<Spinner spinnerType='blue' />										
							}
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default CraneInspectionFormFailOptions;